import { cn } from '@/lib/utils'
import type { ComponentProps, PropsWithChildren } from 'react'

type HeadingType = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'

type Props<T extends HeadingType> = PropsWithChildren & ComponentProps<T> & {}

export function H1({ children, ...props }: Props<'h1'>) {
  return (
    <h1
      {...props}
      className={cn('text-2xl font-bold md:text-4xl mb-4', props.className)}
    >
      {children}
    </h1>
  )
}

export function H2({ children, ...props }: Props<'h2'>) {
  return (
    <h2
      {...props}
      className={cn('text-xl font-semibold md:text-2xl mb-4', props.className)}
    >
      {children}
    </h2>
  )
}

export function H3({ children, ...props }: Props<'h3'>) {
  return (
    <h3
      {...props}
      className={cn('text-lg font-semibold md:text-xl', props.className)}
    >
      {children}
    </h3>
  )
}

export function H4({ children, ...props }: Props<'h4'>) {
  return (
    <h4
      {...props}
      className={cn('text-md font-semibold md:text-lg', props.className)}
    >
      {children}
    </h4>
  )
}

export function H5({ children, ...props }: Props<'h5'>) {
  return (
    <h5
      {...props}
      className={cn('text-sm font-semibold md:text-md', props.className)}
    >
      {children}
    </h5>
  )
}

export function H6({ children, ...props }: Props<'h6'>) {
  return (
    <h6 {...props} className={cn(props.className)}>
      {children}
    </h6>
  )
}
